import styled from 'styled-components';
import vars from '../lib/styled';

export default styled.p.attrs({
    role: 'status'
})`
    background-color: ${props => props.success ? vars.success : vars.primary};
    border-radius: 5px;
    color: #FFF;
    font-size: small;
    padding: .5rem 1.5rem;
    margin-top: 1.5rem;
`;
